module.exports = __webpack_public_path__ + "static/media/sr.7875ba2e.svg";